import MarketAnalysisMarkdownRenderer from 'pages/MasterCampaignPlanPage/new/components/MarketAnalysisMarkdownRenderer'
import { FC } from 'react'

import TabPageHeader from './TabPageHeader'

export interface MarketAnalysisProps {
  accountName: string
  marketAnalysisContent: string
}

const MarketAnalysis: FC<MarketAnalysisProps> = ({ accountName, marketAnalysisContent }) => {
  return (
    <>
      <TabPageHeader title='' />
      <MarketAnalysisMarkdownRenderer content={marketAnalysisContent} />
    </>
  )
}

export default MarketAnalysis
